import {
    FETCH_INVOICING_ERROR,
    FETCH_INVOICING_LOADING,

    FETCH_MERCHANDISER_INVOICING_CHARGES_SUCCESS,
    FETCH_MERCHANDISER_INVOICING_INVOICES_SUCCESS,
    FETCH_MERCHANDISER_INVOICING_JOBS_SUCCESS,
    FETCH_MERCHANDISER_INVOICING_BY_CHARGE_ID_SUCCESS,

    FETCH_CUSTOMER_INVOICING_CHARGES_SUCCESS,
    PATCH_CUSTOMER_CHARGES_BILLABLE_HOURS,
    FETCH_ACCOUNTING_SERVICE_INVOICES_BATCHES_SUCCESS,
    FETCH_ACCOUNTING_CLIENT_INVOICES_BATCHES_SUCCESS,
    FETCH_CUSTOMER_INVOICING_INVOICES_SUCCESS,
    DELETE_CUSTOMER_INVOICING_INVOICES_SUCCESS,
    FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS,
    FETCH_ACCOUNTING_SERVICE_INVOICES_SUCCESS,
    FETCH_ACCOUNTING_CLIENT_INVOICES_SUCCESS,
    FETCH_MISSING_MERCHANDISER_CHARGES_SUCCESS,
    FETCH_MISSING_CLIENT_CHARGES_SUCCESS,
    FETCH_MISSING_MERCHANDISER_CHARGES_LOADING,
    FETCH_MISSING_CLIENT_CHARGES_LOADING, FETCH_RECENT_COMPLETED_SERVICES_SUCCESS,
} from "api/menu/invoicing/actions";

const initialState = {
    loading: false,
    errors: [],
    charges: {},
    invoices: [],
    jobs: [],
    completedServices: [],
    singleCharge: {},

    batchServices: [],
    batchClients: [],

    customerCharges: [],
    customerInvoices: [],
    customerSingleInvoice: {},

    accountingExportServiceInvoices: [],
    accountingExportClientInvoices: [],

    missingMerchandiserCharges: [],
    missingMerchandiserChargesLoading: false,
    missingClientCharges: [],
    missingClientChargesLoading: false,

    exportedData: {}
};

export default function(state = initialState, action) {
    let index,
        customerCharges,
        customerInvoices;
    switch (action.type) {
        case FETCH_INVOICING_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case FETCH_ACCOUNTING_SERVICE_INVOICES_BATCHES_SUCCESS:
            return {
                ...state,
                batchServices: action.payload,
                loading: false
            };
        case FETCH_ACCOUNTING_CLIENT_INVOICES_BATCHES_SUCCESS:
            return {
                ...state,
                batchClients: action.payload,
                loading: false
            };
        case FETCH_INVOICING_ERROR:
            return {
                ...state,
                loading: false,
                errors: action.payload,
            };
        case FETCH_MERCHANDISER_INVOICING_CHARGES_SUCCESS:
            return {
                ...state,
                loading: false,
                charges: action.payload
            };
        case FETCH_MERCHANDISER_INVOICING_INVOICES_SUCCESS:
            return {
                ...state,
                loading: false,
                invoices: action.payload
            };
        case FETCH_MERCHANDISER_INVOICING_JOBS_SUCCESS:
            return {
                ...state,
                loading: false,
                jobs: action.payload
            };
        case FETCH_RECENT_COMPLETED_SERVICES_SUCCESS:
            return {
                ...state,
                loading: false,
                completedServices: action.payload
            };
        case FETCH_MERCHANDISER_INVOICING_BY_CHARGE_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                singleCharge: action.payload
            };

        case FETCH_CUSTOMER_INVOICING_CHARGES_SUCCESS:
            return {
                ...state,
                loading: false,
                customerCharges: action.payload
            };
        case PATCH_CUSTOMER_CHARGES_BILLABLE_HOURS:
            customerCharges = Object.assign([], state.customerCharges);
            index = customerCharges
                .findIndex(item => item.invoiceSummaryId === action.payload.invoiceSummaryId);
            if (index > -1) {
                customerCharges[index] = action.payload;
            }
            return {
                ...state,
                loading: false,
                customerCharges
            };

        case FETCH_CUSTOMER_INVOICING_INVOICES_SUCCESS:
            return {
                ...state,
                loading: false,
                customerInvoices: action.payload
            };
        case DELETE_CUSTOMER_INVOICING_INVOICES_SUCCESS:
            customerInvoices = Object.assign([], state.customerInvoices);
            index = customerInvoices.findIndex(item => item.invoiceId === action.payload);
            if (index > -1) {
                customerInvoices.splice(index, 1);
            }
            return {
                ...state,
                loading: false,
                customerInvoices
            };
        case FETCH_CUSTOMER_INVOICING_INVOICE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                customerSingleInvoice: action.payload
            };
        case FETCH_ACCOUNTING_SERVICE_INVOICES_SUCCESS:
            return {
                ...state,
                loading: false,
                accountingExportServiceInvoices: action.payload
            };
        case FETCH_ACCOUNTING_CLIENT_INVOICES_SUCCESS:
            return {
                ...state,
                loading: false,
                accountingExportClientInvoices: action.payload
            };
        case FETCH_MISSING_MERCHANDISER_CHARGES_SUCCESS:
            return {
                ...state,
                missingMerchandiserChargesLoading: false,
                missingMerchandiserCharges: action.payload
            };
        case FETCH_MISSING_MERCHANDISER_CHARGES_LOADING:
            return {
                ...state,
                missingMerchandiserChargesLoading: action.payload,
            };
        case FETCH_MISSING_CLIENT_CHARGES_SUCCESS:
            return {
                ...state,
                missingClientChargesLoading: false,
                missingClientCharges: action.payload
            };
        case FETCH_MISSING_CLIENT_CHARGES_LOADING:
            return {
                ...state,
                missingClientChargesLoading: action.payload,
            };
        default:
            return state;
    }
}
